<template>
  <div class="portlet">
    <div class="portlet-head">
      <h3><i class="fas fa-clipboard-list mr-2"></i>Lista budów</h3>
      <div>
        <router-link
          tag="button"
          :to="'/construction/' + parent_id + '/add'"
          class="btn btn-sm btn-outline-primary"
        >
          <i class="fas fa-plus"></i> Dodaj
        </router-link>
      </div>
    </div>
    <div class="portlet-body">
      <b-table
        id="subconstructions-table"
        class="table table-list table-mobile m-0 "
        ref="subconstructions_table"
        :fields="fields"
        :busy.sync="isBusy"
        :items="subprojects"
        stacked="lg"
        show-empty
        empty-text="Brak podbudów"
      >
        <template v-slot:table-busy>
          <TableSpiner />
        </template>
        <template v-slot:empty="{ emptyText }">
          <div class="empty">
            <i class="fas fa-clipboard-list empty-state"></i>
            <span class="empty-search">{{ emptyText }}</span>
          </div>
        </template>
        <template v-slot:cell(name)="data">
          <div>
            <router-link :to="'/construction/' + data.item.id"
              >{{ data.item.name }}
              <small v-if="data.item.pur" class="d-block">
                {{ data.item.pur }}</small
              >
            </router-link>
          </div>
        </template>
        <template v-slot:cell(status)="data">
          <label :class="classBadge(data.item.status)">
            {{ statusName(data.item.status) }}
          </label>
        </template>
        <template v-slot:cell(manager)="data">
          {{ data.item.manager.firstname + " " + data.item.manager.lastname }}
        </template>
        <template v-slot:cell(dates)="data">
          od
          <span v-if="data.item.planned_start_date" class="text-dark">
            {{ data.item.planned_start_date | date }}
          </span>
          <span v-else class="text-dark">-</span><br />
          do
          <span v-if="data.item.planned_end_date" class="text-dark">
            {{ data.item.planned_end_date | date }}
          </span>
          <span v-else class="text-dark">-</span>
        </template>
        <template v-slot:cell(important_events)="data">
          <div class="subproject-deadlines"
            v-for="(event, index) in data.item.important_events"
            v-bind:key="index"
          >
            <span v-if="data.item.planned_end_date" class="text-dark">
              {{ event.date | date }}
            </span>
            <span class="subproject-deadlines-label">{{ event.label }}</span>
          </div>
          <i v-if="data.item.important_events <= 0">Brak terminów</i>
        </template>
        <template v-slot:cell(options)="data">
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="$router.push('/construction/' + data.item.id)"
          >
            Przeglądaj
          </button>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {formatDateOnly} from "@/services/helpers";
// import ConstructionsService from "@/services/construction.service";

export default {
  name: "ConstructionSubprojectsPortlet",
  props: {
    parent_id: {
      type: Number,
    },
    subprojects: {
      type: Array,
    },
  },
  data() {
    return {
      selected: {},
      isBusy: false,
      fields: [
        { key: "name", label: "Nazwa" },
        { key: "status", label: "Status" },
        { key: "manager", label: "Kierownik" },
        { key: "dates", label: "Planowane daty" },
        { key: "important_events", label: "Deadlines", thClass: "text-danger" },
        { key: "options", label: "Opcje", class: "text-center" },
      ],
    };
  },
  filters: {
    date(value) {
      return formatDateOnly(value, "YYYY-MM-DD");
    }
  },
  computed: {
    ...mapGetters("app", ["statusName"]),
  },
  created() {},
  methods: {
    ...mapActions("construction", ["remove"]),
    classBadge: function (status) {
      return {
        badge: true,
        "badge-success": status === "finished",
        "badge-primary": status === "in_progress",
        "badge-warning ": status === "not_started",
        "badge-danger ": status === "not_payment",
        "badge-info ": status === "other",
      };
    },
    onClose() {
      this.selected = {};
    },
    onSubmit() {
      this.$refs.subconstructions_table.refresh();
      this.$nextTick(() => {
        this.$bvModal.hide("info-modal");
      });
    },
    modalInfo(subproject_id) {
      this.selected = this.$_.find(this.subprojects, { id: subproject_id });
      this.$nextTick(() => {
        this.$bvModal.show("info-modal");
      });
    },
    // confirmRemove(subproject) {
    //   let h = this.$createElement;
    //   this.$bvModal
    //     .msgBoxConfirm(
    //       [
    //         h("p", [
    //           'Czy napewno chcesz usunąć "',
    //           h("strong", subproject.name),
    //           '"?',
    //         ]),
    //       ],
    //       {
    //         title: "Potwierdź usunięcie podbudowy",
    //         okVariant: "danger",
    //         okTitle: "TAK",
    //         cancelTitle: "NIE",
    //       }
    //     )
    //     .then((result) => {
    //       if (result !== true) {
    //         return;
    //       }
    //       this.$Progress.start();
    //       ConstructionsService.remove(subproject.id).then(() => {
    //         const index = this.subprojects.indexOf(subproject);
    //         this.subprojects.splice(index, 1);
    //         this.$refs.subconstructions_table.refresh();
    //       });
    //     });
    // },
  },
};
</script>
